import { retrieve, create } from "framework/http/endpoint";
import { createEntityRequest } from "framework/http/rest/jsonRequest";
import { UrlPathOfApiLocation } from "common/paths";
var ApiUriPrefix = "".concat(UrlPathOfApiLocation, "/api/1/");
var EventsApiUri = ApiUriPrefix + "events/officials/foreign_adjudicators";
function apiGetForeignAdjudicators(page, pageSize) {
    if (page === void 0) { page = null; }
    if (pageSize === void 0) { pageSize = null; }
    var uri = "".concat(EventsApiUri);
    var queryParams = [];
    if (page !== null) {
        queryParams.push("page=".concat(page));
    }
    if (pageSize !== null) {
        queryParams.push("pageSize=".concat(pageSize));
    }
    if (queryParams.length > 0) {
        uri = uri + '?' + queryParams.join('&');
    }
    return retrieve(uri);
}
function apiCreateForeignAdjudicator(adjudicator) {
    var uri = "".concat(EventsApiUri);
    var request = createEntityRequest(adjudicator);
    return create(uri, request);
}
export { apiGetForeignAdjudicators, apiCreateForeignAdjudicator, };
